import { FranchiseIntranetUpgradeModule } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade.module';
import { FiAppearanceViewState } from '@fi-app/appearance/states/appearance-view-state';
import { FiAppearanceSidebarViewState } from '@fi-app/appearance/states/appearance-sidebar-view-state';
import { FiAppearanceSidebarEditState } from '@fi-app/appearance/states/appearance-sidebar-edit-state';
import { FiAppearanceListViewState } from '@fi-app/appearance/states/appearance-list-view-state';
import { FiAppearanceListViewViewState } from '@fi-app/appearance/states/appearance-list-view-view-state';
import { FiAppearanceListViewEditState } from '@fi-app/appearance/states/appearance-list-view-edit-state';
import { FiAppearanceStartPageEditState } from '@fi-app/appearance/states/appearance-start-page-edit-state';
import { FiAppearanceCustomerSettingsState } from '@fi-app/appearance/states/appearance-customer-settings';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAppearanceSidebarState } from '@fi-app/appearance/states/appearance-sidebar-state';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';

export const FiAppearanceStates: FranchiseIntranetUpgradeModule = {
    states: [
        {
            name: FiStateNames.Appearance._name,
            url: '/Appearance',
            parent: FiStateNames.GlobalSettings,
            abstract: true,
            component: FiAbstractStateComponent,
        },
        FiAppearanceViewState,
        FiAppearanceSidebarState,
        FiAppearanceSidebarViewState,
        FiAppearanceSidebarEditState,
        FiAppearanceListViewState,
        FiAppearanceListViewViewState,
        FiAppearanceListViewEditState,
        FiAppearanceStartPageEditState,
        FiAppearanceCustomerSettingsState,
    ],
};

export function registerAppearanceStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules(
        [
            // FiStateNames.Appearance.View,
            FiStateNames.Appearance.CustomerSettings,
            FiStateNames.Appearance.Sidebar.View,
            FiStateNames.Appearance.Sidebar.Edit,
            FiStateNames.Appearance.StartPage,
            FiStateNames.Appearance.ListView.View,
            FiStateNames.Appearance.ListView.Edit,
        ],
        {
            SettingType: [ApplicationSettingsType.Appearance],
            AccessType: AccessRightType.Admin,
        },
    );
}
